import { render, staticRenderFns } from "./StateRestrictionError.vue?vue&type=template&id=80cc11ec&"
import script from "./StateRestrictionError.vue?vue&type=script&lang=js&"
export * from "./StateRestrictionError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports